import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, signal, WritableSignal } from '@angular/core';
import { ButtonPadding, ButtonVariant } from '@app/components/button/button.component';
import { IconFrame } from '@app/icon-library/lib/pl-icon.component';
import { PlIcon } from '@app/icon-library/icons';
import { ErrorStepData, isStepData, StepData } from '@shared/models/step.model';
import { ApiUrlStep, CourseContentService } from '@app/courseContent/courseContent.service';
import { first } from 'rxjs';

export interface ModalMyLIfeActsBlocksInputs {
  currentlySelectedLifeactFullUrl: string;
}

@Component({
  selector: 'pl-modal-my-life-acts-blocks',
  templateUrl: './modalMyLifeActsBlocks.component.html',
})
export class ModalMyLifeActsBlocksComponent {
  public readonly ButtonPadding: typeof ButtonPadding = ButtonPadding;

  public currentlySelectedLifeactStepData: WritableSignal<StepData | null> = signal(null);
  public stepDataRetrieveInProgress: WritableSignal<boolean> = signal(true);

  public readonly ButtonVariant: typeof ButtonVariant = ButtonVariant;
  public readonly IconFrame: typeof IconFrame = IconFrame;
  public readonly PlIcon: typeof PlIcon = PlIcon;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalMyLIfeActsBlocksInputs,
    private courseContentService: CourseContentService,
    private dialogRef: MatDialogRef<ModalMyLifeActsBlocksComponent, boolean | undefined>,
  ) {
    this.retrieveStepData(data.currentlySelectedLifeactFullUrl);
  }

  public closeModal(): void {
    this.dialogRef.close(false);
  }

  private retrieveStepData(lifeActStepFullUrl: string): void {
    this.courseContentService
      .getStepData(ApiUrlStep.step, lifeActStepFullUrl, { slug: lifeActStepFullUrl })
      .pipe(first())
      .subscribe({
        next: (stepData: StepData | ErrorStepData): void => {
          if (isStepData(stepData)) {
            this.courseContentService.setCurrentStepData(stepData);
            this.currentlySelectedLifeactStepData.set(stepData);
            this.stepDataRetrieveInProgress.set(false);
          } else {
            throw new Error(`Error retrieving lifeact steps`);
          }
        },
      });
  }
}
